module.exports = "/_next/static/images/iphone_white_bar-d785a99306ba3f86bb885de17c020468.png";